import moment from 'moment-timezone';
import destination from 'turf-destination';
import distance from 'turf-distance';
import point from 'turf-point';
import store from '../../../store';
import { getUTC } from '../../../helpers/moment-ex';
import { EventEmitterX } from '../../../helpers/events';
import { isUUID } from '../../../helpers/common';
import { UNKNOWN_OPERATOR, TOPIC_QLOST, TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR } from '../../../constants';

let SlidingMarker = null;
const PRESENTATION_TIME_OFFSET_MS = -3000;
const REFRESH_FREQ_MS = 6000;
const ANIMATION_LEN_MS = 5000;
const REQ_SPEED_MULT = 2;
const RAW_PLACE_SPEED_THRESH = 6;
export const DEFAULT_QLOST_SPAN_SEC = 60;
const CONNECTED_OPACITY = 1;
const DISCONNECTED_OPACITY = 0.5;

class GPSVector {
    constructor(google, seqnum, lat, lng, ts, speed, bearing) {
        this.google = google;
        this.seqnum = parseInt(seqnum);
        this.lat = parseFloat(lat);
        this.lng = parseFloat(lng);
        this.ts = ts;
        this.tempTs = ts;
        this.speed = speed == null ? null : parseFloat(speed);
        this.bearing = bearing == null ? null : parseFloat(bearing);
        this.truncateTs = null;
    }

    /* Returns the lat,lng projected along the vector (positive or negative).
     * ts in milliseconds since epoch.
     */
    getOrigin() {
        return new this.google.maps.LatLng(this.lat, this.lng);
    }

    isTruncated() {
        return this.truncateTs != null;
    }

    getLatLngAtTs(tsRequested) {
        let tsDelta = tsRequested - this.ts;

        if (this.speed == null || this.speed === 0)
            return this.getOrigin()

        if (this.truncateTs != null)
            tsDelta = Math.min(tsRequested, this.truncateTs) - this.ts;

        // If in the future, use the bearing as is, if in the past rotate the vector 180 degrees
        let b = (tsDelta > 0) ? this.bearing : (this.bearing + 180) % 360;
        let distance = (this.speed * Math.abs(tsDelta)) / 1000.0;
        let p = point([this.lng, this.lat]);
        let dest = destination(p, distance, b, 'meters');

        return new this.google.maps.LatLng(dest.geometry.coordinates[1],
            dest.geometry.coordinates[0]);
    }

    truncateVector(ts) {
        if (this.truncateTs == null)
            this.truncateTs = ts;
    }

    addTimeStamp() {
        this.tempTs = this.tempTs + 6000;
    }
}

const getPresentationTimeUTC = (requestedTs) => {
    const tsUTC = requestedTs || (moment.utc().valueOf() + PRESENTATION_TIME_OFFSET_MS);
    return tsUTC;
};

/* const refreshMovement = (markerMapItem, status) => {
    if (markerMapItem.vector == null)
        return;

    const p_time_utc = getPresentationTimeUTC(markerMapItem.vector.tempTs);
    const target = markerMapItem.vector.getLatLngAtTs(p_time_utc + ANIMATION_LEN_MS);
    const curIconPos = markerMapItem.markerObj.getPosition();
    const origin = markerMapItem.vector.getLatLngAtTs(p_time_utc);

    if (typeof curIconPos !== 'undefined') { // Icon on map
        let curPos = point([curIconPos.lng(), curIconPos.lat()]);
        let speed = isNaN(markerMapItem.vector.speed) ? 0 : markerMapItem.vector.speed;

        // Calculate the speed required to reach the point
        let to = point([target.lng(), target.lat()]);
        let dist = distance(curPos, to, 'meters');
        let requiredSpeed = dist / (ANIMATION_LEN_MS / 1000);

        //console.log("dist:" + dist + " speed:" + speed + " req speed:" + requiredSpeed);
        if ((status === 'live') || (requiredSpeed >= RAW_PLACE_SPEED_THRESH && requiredSpeed > (speed * REQ_SPEED_MULT))) {
            // A sweep of this large distance would look bad so just place at now position
            //console.log("Placing due to required speed being " + requiredSpeed + " vs actual speed " + speed);
            //markerMapItem.markerObj.setPositionNotAnimated(origin);

            markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
            markerMapItem.markerObj.setPosition(origin);
            setTimeout(() => {
                markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
                markerMapItem.markerObj.setPosition(target);
            }, 5000);
        } else {
            markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
            markerMapItem.markerObj.setPosition(target);
        }
    } else {
        //markerMapItem.markerObj.setPositionNotAnimated(origin);
        markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
        markerMapItem.markerObj.setPosition(origin);

        markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
        markerMapItem.markerObj.setPosition(target);
    }
}; */

const refreshMovementV1 = (markerMapItem, status) => {
    if (markerMapItem.vector == null)
        return;

    const p_time_utc = getPresentationTimeUTC(markerMapItem.vector.tempTs);
    const target = markerMapItem.vector.getLatLngAtTs(p_time_utc + ANIMATION_LEN_MS);
    const curIconPos = markerMapItem.markerObj.getPosition();
    const origin = markerMapItem.vector.getLatLngAtTs(p_time_utc);

    if (typeof curIconPos !== 'undefined') { // Icon on map
        let curPos = point([curIconPos.lng(), curIconPos.lat()]);
        let speed = isNaN(markerMapItem.vector.speed) ? 0 : markerMapItem.vector.speed;

        // Calculate the speed required to reach the point
        let to = point([target.lng(), target.lat()]);
        let dist = distance(curPos, to, 'meters');
        let requiredSpeed = dist / (ANIMATION_LEN_MS / 1000);

        //console.log("dist:" + dist + " speed:" + speed + " req speed:" + requiredSpeed);
        if ((status === 'live') || (requiredSpeed >= RAW_PLACE_SPEED_THRESH && requiredSpeed > (speed * REQ_SPEED_MULT))) {
            // A sweep of this large distance would look bad so just place at now position
            //console.log("Placing due to required speed being " + requiredSpeed + " vs actual speed " + speed);
            //markerMapItem.markerObj.setPositionNotAnimated(origin);

            markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
            markerMapItem.markerObj.setPosition(new markerMapItem.vector.google.maps.LatLng(markerMapItem.vector.lat,
                markerMapItem.vector.lng));
        }
    } else {
        //markerMapItem.markerObj.setPositionNotAnimated(origin);
        markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
        markerMapItem.markerObj.setPosition(origin);

        markerMapItem.markerObj.setDuration(ANIMATION_LEN_MS);
        markerMapItem.markerObj.setPosition(target);
    }
};

export default class MapMarker extends EventEmitterX {
    constructor(map, google) {
        super();
        this.map = map;
        this.google = google;
        this.ws = null;
        this.markerMap = {}; // device_id to mapping of objects related to maker
        this.lastIntervalFireTs = 0;
        this.refreshSubscribeTimerId = null;
        this.isShowMarker = true;
        this.egList = [];
        this.egReportList = null;
        this.markerLabelType = 1;
        this.storeUnsubscribe = null;
        this.isMessageReceiver = false;
        this.idle = false;
        this.mapMarkersInterval = null;

        this.farmId = null;
        this.isAutoZoom = false;
        this.isFetching = false;
        this.selectedEGList = {};
        this.filteredDeviceIds = [];
        this.init();
    };

    init() {
        if (!SlidingMarker) SlidingMarker = require('marker-animate-unobtrusive');
        this.subscribeStore();
        this.refreshSubscription();
        this.refreshMapMarkers();
    }


    refreshMapMarkers() {
        if (this.mapMarkersInterval) return;
        const me = this;

        this.mapMarkersInterval = setInterval(() => {
            const timeUTC = getUTC().valueOf();
            if ((timeUTC - me.lastIntervalFireTs) < REFRESH_FREQ_MS) {
                console.log("Short circuiting");
                return;
            }

            //console.log("Calling at " + timeUTC);
            this.lastIntervalFireTs = timeUTC;
            Object.keys(me.markerMap).forEach(id => {
                //console.log("Timer calling refreshMovement");
                let markerMapItem = me.markerMap[id];
                if (markerMapItem.vector) markerMapItem.vector.addTimeStamp();
                refreshMovementV1(markerMapItem);
            });
        }, REFRESH_FREQ_MS);
    }

    subscribeStore() {
        this.storeUnsubscribe = store.subscribe(() => {
            const state = store.getState();
            const filteredDeviceIds = state.map.filteredEgList.map(eg => eg.deviceId);
            const egReportIssueList = state.equipmentGroup.EGReportIssue.list;
            this.egReportList = egReportIssueList;

            // Create marker object, subscribe to live data and add marker to the map when app initialized or when farm switched
            if (isEgListChanged(state.map.egList, this.egList)) {
                const farmId = state.farm.currentFarm.farm_uuid;
                this.isAutoZoom = state.map.positionById[farmId] ? false : (this.farmId === farmId) ? state.map.isAutoZoom : true;
                this.farmId = farmId;
                this.isFetching = state.map.isFetching;
                this.markerLabelType = state.user.settings.mapDisplayId;
                this.selectedEGList = {};
                this.filteredDeviceIds = filteredDeviceIds;
                this.show(state.map.egList);
            }
            // Clear all map markers when farm switched or component unmounted
            else if (state.map.isFetching && this.isFetching !== state.map.isFetching) {
                this.egList = [];
                this.isFetching = state.map.isFetching;
                this.clearMarkers();
            }

            // Change visibility of map marker when filtered EG list updated
            if (isFilteredEgListChanged(filteredDeviceIds, this.filteredDeviceIds)) {
                const farmId = state.farm.currentFarm.farm_uuid;
                const isInitialZoom = (this.egList.length === filteredDeviceIds.length) || (filteredDeviceIds.length === 1);
                this.isAutoZoom = state.map.positionById[farmId] ? false : (this.farmId === farmId) ? (isInitialZoom || state.map.isAutoZoom) : true;
                this.showFiltered(filteredDeviceIds);
            }

            this.setSelectedMarkerColor(store.getState().map.egKPIBoxList);
        });
    }

    suspendAndResumeMarkers(visible) {
        this.idle = !visible;

        if (this.idle) {
            this.mapMarkersInterval && clearInterval(this.mapMarkersInterval);
            return;
        }

        this.markerMap && Object.keys(this.markerMap).forEach(deviceId => {
            const markerMapItem = this.markerMap[deviceId];
            if (markerMapItem.lastQPresent) {
                const { lat, lng, ts, speed, bearing } = markerMapItem.lastQPresent;
                const target = this.google.maps.LatLng(lat, lng);
                markerMapItem.markerObj.setPosition(target);

                markerMapItem.lastlocation = { lat, lng };
                const vector = new GPSVector(this.google, 1, lat, lng, ts, speed, bearing);
                this.processVector(vector, markerMapItem);

                delete markerMapItem.lastQPresent;
            }
        });
        this.refreshSubscription();
        this.refreshMapMarkers();
        return;
    }

    show(egList) {
        const { added, removed } = compareEG(this.egList, egList);
        const addedEGList = (added.length > 0) ? this.addMarkers(added) : [];
        if (addedEGList && addedEGList.length > 0) this.subscribe(addedEGList);
        if (removed.length > 0) {
            this.removeMarkers(removed);
            this.emit("removed_markers", removed.map(e => e.egId));
        }
        this.egList = egList;
        if (this.isAutoZoom) this.setBounds();
    }

    showFiltered(deviceIds) {
        const { added, removed } = compareFilteredEG(deviceIds, this.filteredDeviceIds);
        this.filteredDeviceIds = deviceIds;

        // Show map marker if added to filtered list
        added.length > 0 && this.visibleMarkers(added, true);

        // Hide map marker if removed to filtered list
        if (removed.length > 0) {
            this.visibleMarkers(removed, false);
            const removedEgIds = this.markerMap ? removed.filter(id => this.markerMap[id]).map(id => this.markerMap[id].egId) : [];
            this.emit("removed_markers", removedEgIds);
        }
        if (this.isAutoZoom) this.setBounds();
    }

    setBounds() {
        let bounds = null, boundsCount = 0;
        for (const deviceId in this.markerMap) {
            const markerItem = this.markerMap[deviceId];
            if (!(markerItem && markerItem.markerObj && markerItem.markerObj.getMap())) continue;
            if (markerItem.vector) {
                if (!bounds) bounds = new this.google.maps.LatLngBounds();
                bounds.extend(markerItem.vector.getOrigin());
                boundsCount++;
            }
            else if (markerItem.lastlocation) {
                if (!bounds) bounds = new this.google.maps.LatLngBounds();
                const latLng = new this.google.maps.LatLng(markerItem.lastlocation.lat, markerItem.lastlocation.lng);
                bounds.extend(latLng);
                boundsCount++;
            }
        }
        if (bounds && boundsCount > 0) this.map.fitBounds(bounds);
        if (boundsCount === 1) this.setZoom();
    }

    addMarkers(egList) {
        try {
            egList = egList.filter(e => isUUID(e.deviceId));
            if (egList.length === 0) return;

            const me = this;
            const google = this.google;
            const createdItems = [];
            let infowindow = null;

            for (const itemList of egList) {
                let item = itemList;
                if (me.markerMap[item.deviceId]) {
                    if (me.filteredDeviceIds.indexOf(item.deviceId) >= 0)
                        me.visibleMarkers([item.deviceId]);
                    continue;
                }
                const egReportIssue = this.egReportList && this.egReportList[item.egId] ? this.egReportList[item.egId] : null;
                const isResolve = egReportIssue ? egReportIssue.is_resolve : true;
                if (!isResolve) {
                    item = {
                        ...item,
                        ...egReportIssue,
                        iconUrl: item.iconUrl.replace("ic/0", "ic/3"),
                        smallImgUrl: item.iconUrl.replace("ic/0", "ic/3")
                    }
                }
                const isQConnected = item.qConnection ? item.qConnection.connected : false;
                const markerTitle = (this.markerLabelType === 2) ? (item.operatorName || UNKNOWN_OPERATOR) : item.name;
                const marker = new SlidingMarker({
                    map: this.isShowMarker && (me.filteredDeviceIds.indexOf(item.deviceId) >= 0) ? this.map : null,
                    title: markerTitle,
                    icon: {
                        url: item.iconUrl,
                        anchor: new google.maps.Point(32, 32),
                        scaledSize: new google.maps.Size(42, 42)
                    },
                    duration: 2000,
                    easing: "linear"
                });

                google.maps.event.addListener(marker, 'click', () => {
                    this.emit("marker_click", { data: item, marker });
                });

                //set last know location
                const markerItem = { name: item.name, egId: item.egId, markerObj: marker, vector: null, lastReceivedTime: 0, lastNow: moment.utc().valueOf(), lastlocation: null, visible: true };
                if (item.gps && item.gps.loc_point && item.gps.loc_point.length >= 1) {
                    if (item.gps.ts) markerItem.lastReceivedTime = item.gps.ts;
                    const locationPoint = {
                        lat: parseFloat(item.gps.loc_point[1]),
                        lng: parseFloat(item.gps.loc_point[0])
                    };
                    markerItem.lastlocation = locationPoint;

                    // if (isQConnected) {
                    //     const vector = new GPSVector(google, item.gps.seq_num, locationPoint.lat, locationPoint.lng, item.gps.ts,
                    //         item.gps.hasOwnProperty('speed') ? item.gps.speed : null,
                    //         item.gps.hasOwnProperty('bearing') ? item.gps.bearing : null);
                    //     this.processVector(vector, markerItem);
                    // }
                    // else {
                    const coordinate = new this.google.maps.LatLng(locationPoint.lat, locationPoint.lng);
                    marker.setPosition(coordinate);
                    // }
                }

                if (markerItem.vector && item.qConnection && item.qConnection.ts > 0 &&
                    item.qConnection.device_id === item.deviceId) {
                    let tsSpanMs = DEFAULT_QLOST_SPAN_SEC * 1000;
                    if (item.qConnection.hasOwnProperty("keep_alive_interval"))
                        tsSpanMs = parseInt(item.qConnection.keep_alive_interval) * 1000;

                    const lostTs = (item.qConnection.ts - tsSpanMs);
                    markerItem.vector.truncateVector(Math.max(lostTs, markerItem.lastReceivedTime));
                }

                //set opacity
                isQConnected ? marker.setOpacity(CONNECTED_OPACITY) : marker.setOpacity(DISCONNECTED_OPACITY);

                //infowindow
                const contentString = `<div id='infowindow_${item.egId}' class="map-popup_text">${markerTitle}</div>`;
                infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    disableAutoPan: true
                });

                infowindow.addListener('domready', function () {
                    const mapPopupContents = document.getElementsByClassName("map-popup_text");
                    const parentEle = document.getElementsByClassName("gm-style-iw");
                    if (mapPopupContents.length > 0) {
                        for (const element of parentEle) {
                            element.classList.add("map-popup_container");
                        }
                    }
                    me.hideInfoCloseButton(item.egId);
                });

                infowindow.open(this.map, marker);
                me.markerMap[item.deviceId] = markerItem;
                createdItems.push(item);
            }

            return createdItems;
        } catch (ex) {
            throw ex;
        }
    }

    removeMarkers(egList) {
        try {
            for (const item of egList) {
                if (this.markerMap[item.deviceId]) {
                    const markerItem = this.markerMap[item.deviceId];
                    markerItem.visible = false;
                    if (markerItem.markerObj && markerItem.markerObj.getMap())
                        markerItem.markerObj.setMap(null);
                }
            }
        } catch (ex) {
            throw ex;
        }
    }

    visibleMarkers(deviceIds, visible = true) {
        for (const deviceId of deviceIds) {
            if (this.markerMap[deviceId]) {
                const markerItem = this.markerMap[deviceId];
                markerItem.visible = visible;

                if (markerItem.markerObj) {
                    if (!visible && markerItem.markerObj.getMap())
                        markerItem.markerObj.setMap(null);

                    if (visible && this.isShowMarker && markerItem.markerObj.getMap() === null) {
                        markerItem.markerObj.setMap(this.map);
                        this.hideInfoCloseButton(markerItem.egId);
                    }
                }
            }
        }
    }

    subscribe(egList) {
        if (egList.length === 0) return;
        if (!this.ws) this.ws = window.socketClient;
        if (this.ws && !this.isMessageReceiver) {
            this.addMessageReceiver();
            this.isMessageReceiver = true;
        }
        if (!this.ws) return;

        const qTopics = [];
        egList.forEach(item => {
            if (!item.deviceId) return;
            // qTopics.push({ deviceId: item.deviceId, action: TOPIC_LATEST_EG_SENSOR, parameters: { sensor: "gps", equipment_group_uuid: item.egId } });
            qTopics.push({ deviceId: item.deviceId, name: TOPIC_SENSOR, subscribeId: `${item.deviceId}${TOPIC_SENSOR}`, parameters: { sensor_type: "gps" } });
            qTopics.push({ deviceId: item.deviceId, name: TOPIC_QLOST, subscribeId: `${item.deviceId}${TOPIC_QLOST}` });
        });
        if (qTopics.length > 0) this.ws.subscribe(qTopics, "map_gps");
    }

    refreshSubscription() {
        if (this.refreshSubscribeTimerId) return;
        const me = this;
        this.refreshSubscribeTimerId = setInterval(() => {
            const reSubscribeDeviceIds = Object.keys(me.markerMap).filter(deviceId => {
                const lastReceivedTime = me.markerMap[deviceId].lastNow;
                const currentTimeStamp = moment.utc().valueOf();
                const timeDiff = currentTimeStamp - lastReceivedTime;
                return (Math.floor(timeDiff) > (1 * 45 * 1000));
            })

            if (reSubscribeDeviceIds.length > 0)
                me.subscribe(me.egList.filter(eg => reSubscribeDeviceIds.indexOf(eg.deviceId) >= 0));
        }, 1 * 45 * 1000);
    }

    unsubscribe() {
        if (this.ws) this.ws.unsubscribe("map_gps");
    }

    addMessageReceiver() {
        this.ws.addMessageReceiver('map_gps', [TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR, TOPIC_QLOST], live => {
            try {
                if (!live.message || !this.markerMap.hasOwnProperty(live.deviceId)) return;

                if ([TOPIC_LATEST_EG_SENSOR, TOPIC_SENSOR].indexOf(live.name) >= 0) {
                    this.handleQPresent(live);
                    // this.handleQConnection(live);
                } else if ([TOPIC_QLOST].indexOf(live.name) >= 0 && !this.idle) {
                    this.handleQLost(live);
                }
            } catch (ex) {
                console.log(ex.message);
            }
        });
    }

    removeMessageReceiver() {
        if (this.ws) this.ws.removeMessageReceiver('map_gps');
    }

    handleQPresent(live) {
        /* Receiving any qpresent message regardless of contents is valuable information because
        * it provides us with a timestamp where the link was good. */
        const markerItem = this.markerMap[live.deviceId];
        if (!markerItem) return;

        markerItem.lastNow = moment.utc().valueOf();

        const { message } = live;
        const gps = message && message.hasOwnProperty('gps') ? message.gps.data : message;
        if (!gps) return;

        const ts = gps.ts;
        if (ts) {
            if (markerItem.lastReceivedTime === 0 || markerItem.lastReceivedTime < ts)
                this.markerMap[live.deviceId].lastReceivedTime = ts;
            else
                return; // Message older than last, ignore.
        }

        if (!gps) return;
        if (gps.lat && gps.lng) {
            const speed = gps.hasOwnProperty('speed') ? gps.speed : null;
            const bearing = gps.hasOwnProperty('bearing') ? gps.bearing : null;

            if (this.idle) {
                markerItem.lastQPresent = { lat: gps.lat, lng: gps.lng, ts, speed, bearing };
                return;
            }

            markerItem.lastlocation = { lat: gps.lat, lng: gps.lng };
            const vector = new GPSVector(this.google, 1, gps.lat, gps.lng, gps.ts, speed, bearing);
            this.processVector(vector, markerItem);
        }

        if (markerItem.markerObj.getOpacity() === DISCONNECTED_OPACITY)
            markerItem.markerObj.setOpacity(CONNECTED_OPACITY);
    }

    // handleQConnection(live) {
    //     const markerItem = this.markerMap[live.deviceId];
    //     if (markerItem.vector === null) return;

    //     const { message } = live;
    //     if (!message.hasOwnProperty('q_connection')) return;

    //     const qConnection = message.q_connection.data;
    //     let tsSpanMs = (DEFAULT_QLOST_SPAN_SEC * 1000);
    //     let keepAliveInterval = null, connected = null;

    //     if (qConnection.hasOwnProperty("keep_alive_interval"))
    //         keepAliveInterval = parseInt(qConnection["keep_alive_interval"]);
    //     else if (qConnection.hasOwnProperty("keep-alive-interval"))
    //         keepAliveInterval = parseInt(qConnection["keep-alive-interval"]);

    //     if (qConnection.hasOwnProperty("connected"))
    //         connected = qConnection.connected;
    //     else if (keepAliveInterval !== null)
    //         connected = (keepAliveInterval !== DEFAULT_QLOST_SPAN_SEC);

    //     if (connected !== null)
    //         connected ?
    //             markerItem.markerObj.setOpacity(CONNECTED_OPACITY) :
    //             markerItem.markerObj.setOpacity(DISCONNECTED_OPACITY);

    //     if (keepAliveInterval !== null) tsSpanMs = (keepAliveInterval * 1000);
    //     markerItem.vector.truncateVector(Math.max(live.ts - tsSpanMs), markerItem.lastReceivedTime);
    //     refreshMovement(markerItem);
    // }

    handleQLost(live) {
        const markerItem = this.markerMap[live.deviceId];
        if (markerItem.vector === null) return;

        const { message } = live;
        if (!message) return;

        let tsSpanMs = (DEFAULT_QLOST_SPAN_SEC * 1000);
        let keepAliveInterval = null, connected = null;

        if (message.hasOwnProperty("keep_alive_interval"))
            keepAliveInterval = parseInt(message["keep_alive_interval"]);
        else if (message.hasOwnProperty("keep-alive-interval"))
            keepAliveInterval = parseInt(message["keep-alive-interval"]);
        else if (message.parameters && message.parameters.hasOwnProperty("keep-alive-interval"))
            keepAliveInterval = parseInt(message.parameters["keep-alive-interval"]);

        if (message.hasOwnProperty("connected"))
            connected = message.connected;
        else if (message.parameters && message.parameters.hasOwnProperty("connected"))
            connected = message.parameters.connected;
        else if (keepAliveInterval !== null)
            connected = (keepAliveInterval !== DEFAULT_QLOST_SPAN_SEC);

        if (connected !== null)
            connected ?
                markerItem.markerObj.setOpacity(CONNECTED_OPACITY) :
                markerItem.markerObj.setOpacity(DISCONNECTED_OPACITY);

        if (keepAliveInterval !== null) tsSpanMs = (keepAliveInterval * 1000);
        const ts = message.ts ? message.ts : live.ts;
        markerItem.vector.truncateVector(Math.max(ts - tsSpanMs), markerItem.lastReceivedTime);
        refreshMovementV1(markerItem);
    }

    processVector(vector, markerMapItem) {
        markerMapItem.vector = vector;
        //console.log("process Vector calling refreshMovement");
        refreshMovementV1(markerMapItem, 'live');
    }

    setZoom(zoomLevel) {
        const zoomChangeBoundsListener = this.google.maps.event.addListenerOnce(this.map, 'bounds_changed', function (event) {
            if (this.getZoom()) this.setZoom(zoomLevel || 14);
        });
        setTimeout(() => { this.google.maps.event.removeListener(zoomChangeBoundsListener) }, 2000);
    }

    showMarkers() {
        Object.keys(this.markerMap).forEach(id => {
            if (this.markerMap[id].markerObj
                && this.markerMap[id].markerObj.getMap() === null
                && this.markerMap[id].visible
                && this.filteredDeviceIds.indexOf(id) >= 0)
                this.markerMap[id].markerObj.setMap(this.map);
        });
        this.isShowMarker = true;
    }

    hideMarkers() {
        Object.keys(this.markerMap).forEach(id => {
            if (this.markerMap[id].markerObj && this.markerMap[id].markerObj.getMap())
                this.markerMap[id].markerObj.setMap(null);
        });
        this.isShowMarker = false;
    }

    clearMarkers() {
        this.unsubscribe();
        Object.keys(this.markerMap).forEach(id => {
            if (this.markerMap[id].markerObj && this.markerMap[id].markerObj.getMap())
                this.markerMap[id].markerObj.setMap(null);
        });

        this.markerMap = {};
        this.emit("cleared_markers");
    }

    setSelectedMarkerColor(egList) {
        const compare = compareSelectedEG(this.selectedEGList, egList);
        const changes = { ...compare.add, ...compare.changes, ...compare.remove };

        for (const egId in changes) {
            const egItem = changes[egId];
            const egReportIssue = this.egReportList && this.egReportList[egId] ? this.egReportList[egId] : null;
            const isResolve = egReportIssue ? egReportIssue.is_resolve : true;
            if (this.markerMap.hasOwnProperty(egItem.deviceId)) {
                const marker = this.markerMap[egItem.deviceId].markerObj;
                marker.setOptions({
                    icon: {
                        url: replaceURL(marker.getIcon().url, isResolve ? egItem.egState : 3),
                        anchor: new this.google.maps.Point(32, 32),
                        scaledSize: new this.google.maps.Size(42, 42)
                    }
                });
                this.selectedEGList[egId] = egItem;
            }
        }

        for (const egId in compare.remove) {
            if (this.selectedEGList.hasOwnProperty(egId))
                delete this.selectedEGList[egId];
        }
    }

    hideInfoCloseButton(egIds) {
        egIds = !Array.isArray(egIds) ? [egIds] : egIds;
        for (const egId of egIds) {
            const element = document.getElementById(`infowindow_${egId}`);
            if (!element) continue;

            const parent = element.parentElement.parentElement.parentElement;
            if (!parent) continue;

            const childerns = parent.getElementsByClassName("gm-ui-hover-effect");
            if (childerns.length === 0) continue;
            childerns[0].style.display = 'none';
        }
    }

    dispose() {
        if (this.refreshSubscribeTimerId) clearInterval(this.refreshSubscribeTimerId);
        if (this.mapMarkersInterval) clearInterval(this.mapMarkersInterval);
        this.clearMarkers();
        this.removeMessageReceiver();
        if (this.storeUnsubscribe) this.storeUnsubscribe();
    }
}

const compareEG = (a, b) => {
    const obj1 = {}, obj2 = {};
    a.forEach(item => obj1[item.deviceId] = item);
    b.forEach(item => obj2[item.deviceId] = item);

    const added = {}, removed = {};
    for (const key in obj2) {
        if (!obj1.hasOwnProperty(key)) added[key] = obj2[key];
    }

    for (const key in obj1) {
        if (!obj2.hasOwnProperty(key)) removed[key] = obj1[key];
    }

    return {
        added: Object.keys(added).map(id => added[id]),
        removed: Object.keys(removed).map(id => removed[id])
    };
}

const compareSelectedEG = (obj1, obj2) => {
    const addObj = {}, removeObj = {}, changesObj = {};

    for (const key in obj2) {
        if (!obj1.hasOwnProperty(key)) addObj[key] = obj2[key];
    }

    for (const key in obj1) {
        if (!obj2.hasOwnProperty(key))
            removeObj[key] = { ...obj1[key], egState: 0, highlightColor: null };
    }

    for (const key in obj2) {
        if (obj1.hasOwnProperty(key)) {
            const item1 = obj1[key];
            const item2 = obj2[key];
            if (item1.highlightColor !== item2.highlightColor || item1.egState !== item2.egState)
                changesObj[key] = item2;
        }
    }

    return { add: addObj, remove: removeObj, changes: changesObj };
}

const replaceURL = (url, strReplace) => {
    const regExp = /(([\w]+\/){4})([^/]+)(\/.+)/gm;
    const str = '$1' + strReplace + '$4';
    return url.replace(regExp, str);
}

const isEgListChanged = (current, previous) => {
    const currentDeviceIds = current.map(e => e.deviceId).sort().join();
    const previousDeviceIds = previous.map(e => e.deviceId).sort().join();
    return currentDeviceIds !== previousDeviceIds;
}

const isFilteredEgListChanged = (current, previous) => {
    const currentIds = current.sort().join();
    const previousIds = previous.sort().join();
    return currentIds !== previousIds;
}


const compareFilteredEG = (current, previous) => {
    const added = current.filter(id => previous.indexOf(id) < 0);
    const removed = previous.filter(id => current.indexOf(id) < 0);

    return { added, removed };
}